import React, { memo } from "react";
import useStyles from "./styles";
import ProductItem from "components/ProductItem";

import { Grid } from "@material-ui/core";

const Product = props => {
	const classes = useStyles();
	const { listData, updateChangeListProduct, carts, isConditionPromotion } =
		props;

	return (
		<Grid classes={{ root: classes.root }}>
			{listData?.length > 0 &&
				listData?.map(product => (
					<ProductItem
						product={product}
						key={product?.id}
						updateChangeListProduct={updateChangeListProduct}
						products={listData}
						carts={carts}
						isConditionPromotion={isConditionPromotion}
					/>
				))}
		</Grid>
	);
};

export default memo(Product);
